/**
 * @flow
 * @relayHash 5b1cea3a11c1282d05ec59b250361dc7
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type EventSmartSearchPage_viewer$ref = any;
export type EventSmartSearchPageQueryRendererQueryVariables = {|
  eventId: string,
  startnumber: string,
  count: number,
  cursor?: ?string,
  secondFactor?: ?string,
  individualPart?: ?string,
|};
export type EventSmartSearchPageQueryRendererQueryResponse = {|
  +viewer: ?{|
    +$fragmentRefs: EventSmartSearchPage_viewer$ref
  |}
|};
export type EventSmartSearchPageQueryRendererQuery = {|
  variables: EventSmartSearchPageQueryRendererQueryVariables,
  response: EventSmartSearchPageQueryRendererQueryResponse,
|};
*/


/*
query EventSmartSearchPageQueryRendererQuery(
  $eventId: ID!
  $startnumber: ID!
  $count: Int!
  $cursor: String
  $secondFactor: String
  $individualPart: String
) {
  viewer {
    ...EventSmartSearchPage_viewer
    id
  }
}

fragment EventInfoCard_eventInfo on Event {
  id
  sgId
  beginsAt
  banner
  hostHomepageName
  hostHomepageUrl
  location
  name
  predecessorEvent {
    name
    id
  }
}

fragment EventOnlineView_onlineEvent on Event {
  id
  sgId
  hostResultUrl
  ...EventInfoCard_eventInfo
  ...StartNumberSearch_info
  ...ExtendedSearch_event
}

fragment EventSmartSearchPage_viewer on Viewer {
  event(id: $eventId) {
    id
    sgId
    gps
    hostResultUrl
    participant(startnumber: $startnumber, secondFactor: $secondFactor) {
      media {
        mediaInfo {
          count
        }
      }
      suggestions {
        mediaInfo {
          count
        }
        ...SuggestionsMediaList_suggestionsMedia
      }
      startnumber
      id
    }
    secondFactorType {
      type
      id
    }
    searchByFace
    searchByFaceAsFeature
    smartSearch
    state
    ...EventOnlineView_onlineEvent
    ...SuggestionsMediaList_offer
  }
}

fragment ExtendedSearchCategorySearchTab_categories on Event {
  mediaCollections {
    id
    name
  }
  searchAllPhotos
}

fragment ExtendedSearch_event on Event {
  id
  sgId
  searchByFace
  searchByFaceAsFeature
  ...ExtendedSearchCategorySearchTab_categories
}

fragment MediaListItem_item on Media {
  id
  sgId
  name
  shotDate
  variants {
    name
    url
    id
  }
}

fragment MediaList_media on MediaConnection {
  edges {
    node {
      id
      sgId
      shotDate
      variants {
        name
        url
        id
      }
      ...MediaListItem_item
    }
  }
}

fragment MediaList_offer on Event {
  products {
    id
    mediaCollection {
      name
      id
    }
    price
    type
  }
  voucherCampaign {
    banner
    name
    shortText
    id
  }
}

fragment StartNumberSearch_info on Event {
  id
  searchByFace
  secondFactorEventSalt(individualPart: $individualPart)
  secondFactorType {
    type
    id
  }
  sgId
  hostResultUrl
  warnText
}

fragment SuggestionsMediaList_offer on Event {
  ...MediaList_offer
}

fragment SuggestionsMediaList_suggestionsMedia on ExtendedMediaConnection {
  mediaList(first: $count, after: $cursor) {
    edges {
      node {
        id
        __typename
      }
      cursor
    }
    pageInfo {
      hasNextPage
      endCursor
    }
    ...MediaList_media
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "eventId",
    "type": "ID!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "startnumber",
    "type": "ID!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "count",
    "type": "Int!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "cursor",
    "type": "String",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "secondFactor",
    "type": "String",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "individualPart",
    "type": "String",
    "defaultValue": null
  }
],
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "sgId",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "mediaInfo",
  "storageKey": null,
  "args": null,
  "concreteType": "MediaInfo",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "count",
      "args": null,
      "storageKey": null
    }
  ]
},
v4 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "cursor"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "count"
  }
],
v5 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
},
v6 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "type",
  "args": null,
  "storageKey": null
},
v7 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "banner",
  "args": null,
  "storageKey": null
},
v8 = [
  (v5/*: any*/),
  (v1/*: any*/)
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "EventSmartSearchPageQueryRendererQuery",
    "type": "RootQueryType",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "EventSmartSearchPage_viewer",
            "args": null
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "EventSmartSearchPageQueryRendererQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "event",
            "storageKey": null,
            "args": [
              {
                "kind": "Variable",
                "name": "id",
                "variableName": "eventId"
              }
            ],
            "concreteType": "Event",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              (v2/*: any*/),
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "gps",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "hostResultUrl",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "participant",
                "storageKey": null,
                "args": [
                  {
                    "kind": "Variable",
                    "name": "secondFactor",
                    "variableName": "secondFactor"
                  },
                  {
                    "kind": "Variable",
                    "name": "startnumber",
                    "variableName": "startnumber"
                  }
                ],
                "concreteType": "Participant",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "media",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "ExtendedMediaConnection",
                    "plural": false,
                    "selections": [
                      (v3/*: any*/)
                    ]
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "suggestions",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "ExtendedMediaConnection",
                    "plural": false,
                    "selections": [
                      (v3/*: any*/),
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "mediaList",
                        "storageKey": null,
                        "args": (v4/*: any*/),
                        "concreteType": "MediaConnection",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "edges",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "MediaEdge",
                            "plural": true,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "node",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "Media",
                                "plural": false,
                                "selections": [
                                  (v1/*: any*/),
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "__typename",
                                    "args": null,
                                    "storageKey": null
                                  },
                                  (v2/*: any*/),
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "shotDate",
                                    "args": null,
                                    "storageKey": null
                                  },
                                  {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "variants",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "MediaFile",
                                    "plural": true,
                                    "selections": [
                                      (v5/*: any*/),
                                      {
                                        "kind": "ScalarField",
                                        "alias": null,
                                        "name": "url",
                                        "args": null,
                                        "storageKey": null
                                      },
                                      (v1/*: any*/)
                                    ]
                                  },
                                  (v5/*: any*/)
                                ]
                              },
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "cursor",
                                "args": null,
                                "storageKey": null
                              }
                            ]
                          },
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "pageInfo",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "PageInfo",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "hasNextPage",
                                "args": null,
                                "storageKey": null
                              },
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "endCursor",
                                "args": null,
                                "storageKey": null
                              }
                            ]
                          }
                        ]
                      },
                      {
                        "kind": "LinkedHandle",
                        "alias": null,
                        "name": "mediaList",
                        "args": (v4/*: any*/),
                        "handle": "connection",
                        "key": "SuggestionsMediaList_mediaList",
                        "filters": null
                      }
                    ]
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "startnumber",
                    "args": null,
                    "storageKey": null
                  },
                  (v1/*: any*/)
                ]
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "secondFactorType",
                "storageKey": null,
                "args": null,
                "concreteType": "SecondFactorType",
                "plural": false,
                "selections": [
                  (v6/*: any*/),
                  (v1/*: any*/)
                ]
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "searchByFace",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "searchByFaceAsFeature",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "smartSearch",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "state",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "beginsAt",
                "args": null,
                "storageKey": null
              },
              (v7/*: any*/),
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "hostHomepageName",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "hostHomepageUrl",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "location",
                "args": null,
                "storageKey": null
              },
              (v5/*: any*/),
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "predecessorEvent",
                "storageKey": null,
                "args": null,
                "concreteType": "Event",
                "plural": false,
                "selections": (v8/*: any*/)
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "secondFactorEventSalt",
                "args": [
                  {
                    "kind": "Variable",
                    "name": "individualPart",
                    "variableName": "individualPart"
                  }
                ],
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "warnText",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "mediaCollections",
                "storageKey": null,
                "args": null,
                "concreteType": "MediaCollection",
                "plural": true,
                "selections": [
                  (v1/*: any*/),
                  (v5/*: any*/)
                ]
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "searchAllPhotos",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "products",
                "storageKey": null,
                "args": null,
                "concreteType": "Product",
                "plural": true,
                "selections": [
                  (v1/*: any*/),
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "mediaCollection",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "MediaCollection",
                    "plural": false,
                    "selections": (v8/*: any*/)
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "price",
                    "args": null,
                    "storageKey": null
                  },
                  (v6/*: any*/)
                ]
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "voucherCampaign",
                "storageKey": null,
                "args": null,
                "concreteType": "VoucherCampaign",
                "plural": false,
                "selections": [
                  (v7/*: any*/),
                  (v5/*: any*/),
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "shortText",
                    "args": null,
                    "storageKey": null
                  },
                  (v1/*: any*/)
                ]
              }
            ]
          },
          (v1/*: any*/)
        ]
      }
    ]
  },
  "params": {
    "operationKind": "query",
    "name": "EventSmartSearchPageQueryRendererQuery",
    "id": null,
    "text": "query EventSmartSearchPageQueryRendererQuery(\n  $eventId: ID!\n  $startnumber: ID!\n  $count: Int!\n  $cursor: String\n  $secondFactor: String\n  $individualPart: String\n) {\n  viewer {\n    ...EventSmartSearchPage_viewer\n    id\n  }\n}\n\nfragment EventInfoCard_eventInfo on Event {\n  id\n  sgId\n  beginsAt\n  banner\n  hostHomepageName\n  hostHomepageUrl\n  location\n  name\n  predecessorEvent {\n    name\n    id\n  }\n}\n\nfragment EventOnlineView_onlineEvent on Event {\n  id\n  sgId\n  hostResultUrl\n  ...EventInfoCard_eventInfo\n  ...StartNumberSearch_info\n  ...ExtendedSearch_event\n}\n\nfragment EventSmartSearchPage_viewer on Viewer {\n  event(id: $eventId) {\n    id\n    sgId\n    gps\n    hostResultUrl\n    participant(startnumber: $startnumber, secondFactor: $secondFactor) {\n      media {\n        mediaInfo {\n          count\n        }\n      }\n      suggestions {\n        mediaInfo {\n          count\n        }\n        ...SuggestionsMediaList_suggestionsMedia\n      }\n      startnumber\n      id\n    }\n    secondFactorType {\n      type\n      id\n    }\n    searchByFace\n    searchByFaceAsFeature\n    smartSearch\n    state\n    ...EventOnlineView_onlineEvent\n    ...SuggestionsMediaList_offer\n  }\n}\n\nfragment ExtendedSearchCategorySearchTab_categories on Event {\n  mediaCollections {\n    id\n    name\n  }\n  searchAllPhotos\n}\n\nfragment ExtendedSearch_event on Event {\n  id\n  sgId\n  searchByFace\n  searchByFaceAsFeature\n  ...ExtendedSearchCategorySearchTab_categories\n}\n\nfragment MediaListItem_item on Media {\n  id\n  sgId\n  name\n  shotDate\n  variants {\n    name\n    url\n    id\n  }\n}\n\nfragment MediaList_media on MediaConnection {\n  edges {\n    node {\n      id\n      sgId\n      shotDate\n      variants {\n        name\n        url\n        id\n      }\n      ...MediaListItem_item\n    }\n  }\n}\n\nfragment MediaList_offer on Event {\n  products {\n    id\n    mediaCollection {\n      name\n      id\n    }\n    price\n    type\n  }\n  voucherCampaign {\n    banner\n    name\n    shortText\n    id\n  }\n}\n\nfragment StartNumberSearch_info on Event {\n  id\n  searchByFace\n  secondFactorEventSalt(individualPart: $individualPart)\n  secondFactorType {\n    type\n    id\n  }\n  sgId\n  hostResultUrl\n  warnText\n}\n\nfragment SuggestionsMediaList_offer on Event {\n  ...MediaList_offer\n}\n\nfragment SuggestionsMediaList_suggestionsMedia on ExtendedMediaConnection {\n  mediaList(first: $count, after: $cursor) {\n    edges {\n      node {\n        id\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      hasNextPage\n      endCursor\n    }\n    ...MediaList_media\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'e00d3c957e6b24d6b0b063ac6753258f';

module.exports = node;
